import { render } from "./ProgrammaLavoro.vue?vue&type=template&id=680c54dc&scoped=true&ts=true"
import script from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"
export * from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"

import "./ProgrammaLavoro.vue?vue&type=style&index=0&id=680c54dc&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_save-group_1779204252500559514/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680c54dc"]])

export default __exports__